// extracted by mini-css-extract-plugin
export default {"Root":"scrollArea_Root__pDA-H","Viewport":"scrollArea_Viewport__o7J-g","Scrollbar":"scrollArea_Scrollbar__QwIfp","Thumb":"scrollArea_Thumb__7AWHJ","Tag":"scrollArea_Tag__IIbEA"};